import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import Button from '../button';
export default function PickerButton(props) {
  return /*#__PURE__*/React.createElement(Button, _extends({
    size: "small",
    type: "primary"
  }, props));
}